import React, { useState } from "react";
import { PORTAL_LINK } from "../../../../environments/env";
import axios from "axios";
import { message, Popconfirm, Spin } from "antd";
import ENVIRONMENT from "../../../../environments";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";


const WalmartOauthCard = () => {
    const [disconnecting, setDisconnecting] = useState(false);

    const handleAuthorize = () => {
        const authUrl = `https://login.account.wal-mart.com/authorize?responseType=code&clientId=c4022037-a5fd-4886-a8df-3f72abbde99c&redirectUri=${PORTAL_LINK}walmart-callback&nonce=AVE1DCZ5FG&state=A0YFFJJQMD&clientType=seller`;
        window.open(authUrl, "_blank");
    }

    const handleDisconnect = () => {
        setDisconnecting(true);
        axios.post(ENVIRONMENT.WALMART_DISCONNECT, {
            username: localStorage.getItem('username')
        })
            .then((res) => {
                if (res.status === 200) {
                    localStorage.removeItem('walmart_authorized');
                    message.success("Disconnected from Walmart");
                }
            })
            .catch((error) => {
                message.error("Error disconnecting from Walmart");
            })
            .finally(() => {
                setDisconnecting(false);
            })
    }

    const isAuthorized = localStorage.getItem('walmart_authorized') === 'true';

    return (
        <div className="integration-card">
            <p className="manrope f-24">Authorize to Walmart</p>
            <img
                style={{ width: 120, height: 40, objectFit: "contain", display: "block", margin: "24px auto" }}
                src={require("../../../../assets/images/walmart_logo.svg")}
                alt="walmart-logo"
            />
            <p className="manrope f-14 mt-40" style={{ marginTop: "60px" }}>
                Integrate your Walmart account to easily upload your products from our platform.
            </p>

            {isAuthorized ? (
                <Popconfirm
                    title="Are you sure you want to disconnect Walmart?"
                    onConfirm={handleDisconnect}
                    okText="Yes"
                    cancelText="No"
                >
                    <button className="disconnect-button" disabled={disconnecting}>
                        {disconnecting ? (
                            <>
                                <Spin size="small" /> Disconnecting...
                            </>
                        ) : (
                            "Disconnect"
                        )}
                    </button>
                </Popconfirm>
            ) : (
                <button className="auhtorize-button" onClick={handleAuthorize}>
                    Authorize
                </button>
            )}
        </div>
    );

}

export default WalmartOauthCard;